// Google Analytics Helper Functions

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

// Initialize Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('Google Analytics Measurement ID not found');
    return;
  }

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
};

// Track page views
export const pageview = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// E-commerce tracking

// Track product view
export const trackProductView = (product) => {
  event({
    action: 'view_item',
    category: 'Ecommerce',
    label: product.name,
    value: product.basePrice,
  });

  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'view_item', {
      currency: 'INR',
      value: product.basePrice,
      items: [
        {
          item_id: product._id,
          item_name: product.name,
          item_category: product.category,
          price: product.basePrice,
          quantity: 1,
        },
      ],
    });
  }
};

// Track add to cart
export const trackAddToCart = (product, quantity = 1) => {
  event({
    action: 'add_to_cart',
    category: 'Ecommerce',
    label: product.name,
    value: product.basePrice * quantity,
  });

  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'add_to_cart', {
      currency: 'INR',
      value: product.basePrice * quantity,
      items: [
        {
          item_id: product._id,
          item_name: product.name,
          item_category: product.category,
          price: product.basePrice,
          quantity: quantity,
        },
      ],
    });
  }
};

// Track purchase
export const trackPurchase = (order) => {
  event({
    action: 'purchase',
    category: 'Ecommerce',
    label: order.orderId,
    value: order.totalAmount,
  });

  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'purchase', {
      transaction_id: order.orderId,
      value: order.totalAmount,
      currency: 'INR',
      tax: 0,
      shipping: 0,
      items: order.items.map((item) => ({
        item_id: item.productId,
        item_name: item.productName,
        item_category: item.category,
        price: item.price,
        quantity: item.quantity,
      })),
    });
  }
};

// Track begin checkout
export const trackBeginCheckout = (cart) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'begin_checkout', {
      currency: 'INR',
      value: cart.total,
      items: cart.items.map((item) => ({
        item_id: item._id,
        item_name: item.name,
        item_category: item.category,
        price: item.basePrice,
        quantity: item.quantity,
      })),
    });
  }
};

// Track search
export const trackSearch = (searchTerm) => {
  event({
    action: 'search',
    category: 'Engagement',
    label: searchTerm,
  });
};

// Track video play
export const trackVideoPlay = (productName, videoUrl) => {
  event({
    action: 'video_play',
    category: 'Engagement',
    label: productName,
  });
};
